namespace Matrix.Data {

	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
    export class MergeSecuritiesDialog extends Serenity.TemplatedDialog<any> {

        public grid: MergeSecuritiesGrid;

        constructor() {
            super();

            this.grid = new MergeSecuritiesGrid(this.element.children());
        }

        protected getTemplate() {
			return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}